import { render, staticRenderFns } from "./ShouninKintaiLocalHeader.vue?vue&type=template&id=2791b9b9&scoped=true&"
import script from "./ShouninKintaiLocalHeader.vue?vue&type=script&lang=ts&"
export * from "./ShouninKintaiLocalHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ShouninKintaiLocalHeader.vue?vue&type=style&index=0&id=2791b9b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2791b9b9",
  null
  
)

export default component.exports